/**
 * This component exists to handle top level behaviour within the _app.tsx file that requires accessing context state from a top level provider.
 */
import { useEffect } from 'react';

import { brazeService } from 'services/brazeService';
import { useUserContext } from 'contexts/UserContext';
import { useAuthOptions } from 'hooks/useAuthOptions';

const AppConsumer = () => {
  const {
    consentOptions: { allowBraze },
  } = useUserContext();
  const { isAuthenticated } = useAuthOptions();

  useEffect(() => {
    if (isAuthenticated && allowBraze) brazeService();
  }, [allowBraze, isAuthenticated]);
  return <></>;
};

export { AppConsumer };
